/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ListOperators } from '../models/ListOperators';

export class TagKeysCondition {
  'operator': ListOperators;
  'tagKeys': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ListOperators",
      "format": ""
    },
    {
      "name": "tagKeys",
      "baseName": "tagKeys",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return TagKeysCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



